import { render, staticRenderFns } from "./TruckReleaseList.vue?vue&type=template&id=7b28d9de&scoped=true&"
import script from "./TruckReleaseList.vue?vue&type=script&lang=js&"
export * from "./TruckReleaseList.vue?vue&type=script&lang=js&"
import style0 from "./TruckReleaseList.vue?vue&type=style&index=0&id=7b28d9de&scoped=true&lang=less&"
import style1 from "./TruckReleaseList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28d9de",
  null
  
)

export default component.exports